import { type SurveyStep } from '../store'

export function getModalTitle(step: SurveyStep) {
  switch (step) {
    case 'introduction':
      return 'Pesquisa de preferência sobre a troca de cartões Swile'
    case 'recarding-preference-question':
      return 'Como sua empresa prefere realizar a troca dos cartões?'
    case 'success':
      return 'Sua escolha foi registrada'
  }
}
